// import React, { useState, useRef, useEffect } from "react";

import ViewItemRelocate from "../../../../components/@documents/item_relocates/ViewItemRelocate";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemRelocateViewPage() {

    return (
        <ViewItemRelocate 
            routeType={routeTypes.workstation}
        />
    )
}